// Column shapes for the Resource Management page's loading skeletons, kept in
// sync with the real DataTable columns so the skeleton never drifts from the
// actual table structure.

export const RESOURCE_PROJECT_SKELETON_COLUMNS = [
  { key: "project_name", label: "Project Name" },
  { key: "capacity_percent", label: "Capacity %" },
  { key: "start_date", label: "Start Date" },
  { key: "end_date", label: "End Date" },
  { key: "status", label: "Status" },
  { key: "actions", label: "Actions", width: 80 }
];

export const RESOURCE_TEAM_OVERVIEW_SKELETON_COLUMNS = [
  { key: "employee_name", label: "Employee" },
  { key: "department_name", label: "Department" },
  { key: "project_count", label: "Projects" },
  { key: "total_capacity_percent", label: "Total Capacity" },
  { key: "status", label: "Status" },
  { key: "remark", label: "Remark" }
];
